import React, { useRef, useLayoutEffect } from 'react'
import { useRenderCounter } from '../lib/hooks/useRenderCounter'
import gsap from 'gsap'

interface Props {
  className?: string
  cx: number
  cy: number
  r: number
  animationDurationSec?: number
  [k: string]: any
}

export const AnimatedCircle: React.FC<Props> = ({
  className = '',
  cx,
  cy,
  r,
  animationDurationSec = 0.3,
  ...props
}) => {
  const circleRef = useRef(null)
  const renderCount = useRenderCounter()

  useLayoutEffect(() => {
    if (circleRef.current) {
      const attr = { cx, cy, r }
      if (renderCount === 0) {
        gsap.set(circleRef.current, { attr })
      } else {
        gsap.to(circleRef.current, { attr, duration: animationDurationSec })
      }
    }
  }, [cx, cy, r])

  return <circle className={`-animated-circle ${className}`} ref={circleRef} {...props} />
}
